import React, { Component } from 'react';
//import {FormBlocks} from './FormBlocks';
//import {formFieldsAttributes} from '../../actions/FieldProps';
//import {formFieldsAttributes} from '../../../../../src/plugins/FormBuilder/actions/FieldProps';
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat} from '../../../Utils/UserFunctions';
import Wrp from '../../../hoc/Wrp/Wrp';
import { numericValidation} from '../../../Utils/CommonFunctions';


class DatePick extends Component {
  constructor(props) {
      super();
      this.state = {
        dt: moment(),
        setDt: moment()
      };
    }
    
  render() {
    let filterObject = this.props.filterObject;     
    // console.log(this.props.value   + ' operator properties')
    let value = this.props.value;
    let classname = this.props.classname ? "form-control "+this.props.classname : "form-control";
    // console.log(getDateFormat('Date'), value);
    return (
      <Wrp>
        {
        (filterObject.input_value_type==='Timestamp')
        ?
        <Datetime 
        timeFormat={false} 
        value={ this.props.value ? moment(this.props.value).format(getDateFormat('Date')) : ''}
        // value={this.props.value} 
        //value={ this.props.value ? moment(this.props.value).format(getDateFormat(this.props.attr2)) : ''}
        dateFormat={getDateFormat('Date')} 
        closeOnSelect={true}  
        onChange={e=>this.props.filterOnChange(e, this.props.attr1, this.props.fieldtype, filterObject.has_multiple_input,this.props.attr5,this.props.attr6)}  
        />
        : filterObject.input_value_type === "Integer" ?
        <Wrp>
        <input type="number" value={this.props.value} className={classname} onKeyPress={numericValidation} onChange={e=>this.props.filterOnChange(e, this.props.attr1, 'inputField', filterObject.has_multiple_input,this.props.attr4,this.props.attr6)} /> 
          {filterObject.name === "is in" ? "day(s) next" : "day(s) ago"}
        </Wrp>
        : null
        }
      </Wrp>
      

    )
  }
}

DatePick.defaultProps = {
className:'form-control'
//id:"replaceColumnInput"+JSON.parse(this.props.fieldDetails.colIndex)
}

export default DatePick;
